import React, { Fragment, useState } from "react";
import Typography from "../Typography/Typography";
import { ActivitesDoneTodayStyle } from "./ActivitiesDoneTodayStyle";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useGetActivitiesDoneToday, useGetCustomer } from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { Link } from "react-router-dom";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
export const ActivitiesDoneToday = () => {
  const [search, setSearch] = useState();
  const { data, isLoading } = useGetActivitiesDoneToday();
  const { data: customerresponsible } = useGetCustomer();
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const activities = data?.data?.activity_crms;
  const users = data?.data?.File_User_activity_crms;
  var activitiesLength = 0;
  const actions = activities
    ?.filter((user) => {
      if (search === undefined) {
        return user;
      } else if ((user.FirstName + " " + user.LastName).includes(search)) {
        activitiesLength += 1;
        return user;
      }
    })
    .map((action, index) => {
      return (
        <Fragment key={index}>
          <div className="img-holder col-lg-1 col-md-1 col-sm-2 col-2 mb-2 d-flex justify-content-center">
            <img
              src={`https://api.mahanskinclinic.com/thumbnail/Profile/${action.Image}`}
              alt="image"
              className="img-fluid rounded-circle"
            />
          </div>
          <div className="card-holder col-lg-11 col-md-11 col-sm-10 col-10 mb-2">
            <div className="card-">
              <div className="part-1 d-flex">
                <div className="flex-fill">
                  <div className="d-flex">
                    <AiOutlineCheckCircle className="checkmark" />

                    <>
                      <Typography
                        size="14px"
                        weight="bold"
                        className="text-wrap subject"
                      >
                        <Link
                          to={`/dashboard/crm/customer-file/${action.IdS0alesOpportunities}`}
                        >
                          {action.SubjectActivityCrm}
                          {users?.map((item) =>
                            item?.IdS0alesOpportunities ===
                            action.IdS0alesOpportunities
                              ? `(${
                                  (item?.FirstName ? item?.FirstName : "") +
                                  " " +
                                  (item?.LastName ? item?.LastName : "")
                                })`
                              : ""
                          )}
                        </Link>
                      </Typography>
                    </>
                  </div>
                  <Typography className="description mt-2 mx-2 text-break">
                    {action.DescriptionActivityCrm}
                  </Typography>
                  <div className="d-flex justify-content-between">
                    <Typography className="mx-2 mt-3 recorddate" size="12px">
                      ثبت شده توسط {action.FirstName + " " + action.LastName}
                    </Typography>
                    <Typography className="mx-2 mt-3 createdate" size="12px">
                      تاریخ فعالیت: {MiladiToShamsi(action.created_at)}
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="part-2">
                <div className="w-100">
                  <Typography className="action-answer">
                    {action.AnswerActivityCrm}
                  </Typography>
                  <div className="d-flex justify-content-between">
                    <Typography className="answer-record mx-2" size="12px">
                      ثبت شده توسط{" "}
                      {data?.data?.UserAnswerActivityCrm.map((user) =>
                        user.IdActivityCrm === action.IdActivityCrm
                          ? user.FirstName + " " + user.LastName
                          : ""
                      )}
                    </Typography>
                    <Typography className="answer-date mx-2" size="12px">
                      تاریخ جواب : {MiladiToShamsi(action.updated_at)}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
    });

  const inputRef = null;
  return !isLoading ? (
    <ActivitesDoneTodayStyle className="mt-3">
      <BreadCrumb
        margin="mt-3"
        num1="واحد CRM"
        num2="گزارشگیری"
        num3="فعالیت های امروز انجام شده"
        href1="/dashboard/crm"
        href2="/dashboard/crm/reporting"
      />
      <div className="w-100 activity-container">
        <div className="header">
          <Typography size="14px">
            فعالیت های انجام شده{" "}
            {search !== undefined ? activitiesLength : activities.length}
          </Typography>
        </div>
        <div className="body row m-0">
          <div className="col-12 d-flex justify-content-center mb-2">
            <div className="searchbyresponsible w-25">
              <SimpleSelect1
                res={customerResponsibleOptions}
                onChange={(e) => {
                  if (!e) {
                    e = {
                      target: inputRef,
                      value: "",
                    };
                  }
                  setSearch(e.label);
                }}
              />
            </div>
          </div>
          {actions}
        </div>
      </div>
    </ActivitesDoneTodayStyle>
  ) : (
    <Loading />
  );
};
